__turbopack_context__.v({
  "btnContainer": "MagicModalNew-module__58VrMG__btnContainer",
  "magicModalFadeIn": "MagicModalNew-module__58VrMG__magicModalFadeIn",
  "modal": "MagicModalNew-module__58VrMG__modal",
  "modalContainer": "MagicModalNew-module__58VrMG__modalContainer",
  "root": "MagicModalNew-module__58VrMG__root",
  "srOnly": "MagicModalNew-module__58VrMG__srOnly",
});
